export const createDataStreamsSlice = (set) => ({
    highlightedDataStreams: [],
    hiddenDataStreams: [],
    highlightDataStream: (datastream) => set((state) => {
        if (!datastream)
            return state;
        return {
            highlightedDataStreams: [...state.highlightedDataStreams, datastream],
        };
    }),
    unHighlightDataStream: (datastream) => set((state) => {
        if (!datastream)
            return state;
        return {
            highlightedDataStreams: state.highlightedDataStreams.filter(({ id }) => id !== datastream.id),
        };
    }),
    hideDataStream: (datastream) => set((state) => {
        if (!datastream)
            return state;
        return {
            hiddenDataStreams: [...state.hiddenDataStreams, datastream],
            /**
             * unhighlight the datastream if it's hidden so it does not
             * make the other streams de-emphasized
             */
            highlightedDataStreams: state.highlightedDataStreams.filter(({ id }) => id !== datastream.id),
        };
    }),
    unHideDataStream: (datastream) => set((state) => {
        if (!datastream)
            return state;
        return {
            hiddenDataStreams: state.hiddenDataStreams.filter(({ id }) => id !== datastream.id),
        };
    }),
});
